import { render, staticRenderFns } from "./EditVolumeNameDialog.vue?vue&type=template&id=f6bf3416"
import script from "./EditVolumeNameDialog.vue?vue&type=script&lang=js"
export * from "./EditVolumeNameDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports